import { Switch as AntSwitch } from "antd";
import type { SwitchProps as AntSwitchProps } from "antd";

interface CustomSwitchProps extends AntSwitchProps {
  label?: string;
  error?: string;
  labelClassName?: string;
}

export function Switch({ label, error, labelClassName, ...props }: CustomSwitchProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <AntSwitch {...props} />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
